module.exports = __webpack_public_path__ + "img/lidzhanova.164cd8f6.jpg";